import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';
import { ColorRing } from 'react-loader-spinner';

import VulsChartTitle from './VulsChartTitle';
import { vulCurrentTypeLineChartOptions } from './charOptionByType';

import { useGetVulsLineChartState } from 'hooks/Analitics/VulsCharts/1_PeriodVulsLineChart/useGetVulsLineChartState';

interface ChartProps {
  slug: string;
}

const VulsPeriodLineChart: React.FC<ChartProps> = ({ slug }) => {
  const {
    startDate,
    endDate,
    chartData,
    setStartDate,
    setEndDate,
    vulType,
    setVulType,
    isLoading,
    period,
    handlePeriodChange,
  } = useGetVulsLineChartState({ slug });
  const { t } = useTranslation();
  const chartOptions = vulCurrentTypeLineChartOptions(chartData || {}, t, vulType);

  return (
    <div className="card m-0 border border-2 rounded-4 position-relative">
      <div className="card-header rounded-4">
        <VulsChartTitle
          title={t('ChartsAnalitics.vuls_period_line_chart.title')}
          period={period}
          handlePeriodChange={handlePeriodChange}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          vulType={vulType}
          setVulType={setVulType}
        />
      </div>
      <div className="card-body">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
            <ColorRing
              visible
              height="80"
              width="80"
              ariaLabel="color-ring-loading"
              wrapperStyle={{}}
              wrapperClass="color-ring-wrapper"
              colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
            />
          </div>
        ) : (
          <div className="position-relative">
            <ReactApexChart options={chartOptions} series={chartOptions.series} type="area" height={350} />
          </div>
        )}
      </div>
    </div>
  );
};

export default VulsPeriodLineChart;
